import { Facebook, Linkedin, Instagram, Youtube, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { EXTERNAL_LINKS, NAV_LINKS, CONTACT } from "@/lib/site-data";

const socials = [
  { icon: Facebook, href: EXTERNAL_LINKS.facebook, label: "facebook" },
  { icon: Instagram, href: EXTERNAL_LINKS.instagram, label: "instagram" },
  { icon: Linkedin, href: EXTERNAL_LINKS.linkedin, label: "linkedin" },
  { icon: Youtube, href: EXTERNAL_LINKS.youtube, label: "youtube" },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary text-secondary-foreground pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="mb-6 bg-white rounded-2xl p-4 inline-block shadow-lg">
              <img src="/studyvia-logo.png" alt="Studyvia Private Limited" className="h-40 w-auto" />
            </div>
            <p className="text-white/60 max-w-md leading-relaxed">
              Studyvia Private Limited — authorised franchise partner of MSM
              Unify and Career Banale, and the exclusive online-degree partner
              of Florida Coastal University (USA), delivering study-abroad,
              Indian degrees, test prep and career programs.
            </p>
            <div className="flex gap-3 mt-8">
              {socials.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${label}`}
                  aria-label={label}
                  className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:bg-primary hover:border-primary hover:text-primary-foreground transition-colors duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/75 hover:text-primary transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
            <div className="mt-6 space-y-3">
              <a href={EXTERNAL_LINKS.msmunify} target="_blank" rel="noopener noreferrer" data-testid="footer-msmunify" className="flex items-center gap-1 text-white/75 hover:text-primary transition-colors">
                MSM Unify Global <ArrowUpRight size={14} />
              </a>
              <a href={EXTERNAL_LINKS.careerbanale} target="_blank" rel="noopener noreferrer" data-testid="footer-careerbanale" className="flex items-center gap-1 text-white/75 hover:text-primary transition-colors">
                Career Banale <ArrowUpRight size={14} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Get in touch</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-white/75">
                <MapPin size={18} className="text-primary" /> {CONTACT.address}
              </li>
              <li className="flex items-center gap-3 text-white/75">
                <Mail size={18} className="text-primary" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-primary transition-colors">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-3 text-white/75">
                <Phone size={18} className="text-primary" />
                <a href={`tel:${CONTACT.phone}`} className="hover:text-primary transition-colors">{CONTACT.phone}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive typography */}
        <div className="py-10 overflow-hidden">
          <h2 className="font-display text-[20vw] leading-none text-white/[0.06] font-medium tracking-tight text-center select-none">
            STUDYVIA
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Studyvia, Bhubaneswar. All rights reserved.</p>
          <p>In partnership with MSM Unify & Career Banale</p>
        </div>
      </div>
    </footer>
  );
}
